// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";

// core styles
import "./scss/volt.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";

const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
};

const resizeObserverLoopErrRe = /^ResizeObserver loop limit exceeded/;

const resizeObserverLoopErrHandler = (e) => {
    if (resizeObserverLoopErrRe.test(e.message)) {
        e.stopImmediatePropagation();
    }
};

window.addEventListener('error', resizeObserverLoopErrHandler);

// Override ResizeObserver prototype to debounce the callback
const originalRO = window.ResizeObserver;
window.ResizeObserver = function(callback) {
    const debouncedCallback = debounce(callback, 100);
    return new originalRO(debouncedCallback);
};

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <HomePage />
  </BrowserRouter>,
  document.getElementById("root")
);
